/* 채널톡 관련 개발 @ahn */
/* https://developers.channel.io/reference/welcome-to-channel-kr */

import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { format } from 'libphonenumber-js'
import { components } from '../constants/schema'

const CHANNEL_KEY = '759b1739-ca8c-41ac-b2b7-6a6668761bd0'

export type ChUser = {
  id?: number
  name?: string
  email?: string
  identification?: ChIdentification
}

export type ChProfile = {
  name?: string
  email?: string
  mobileNumber?: string
}

export type ChBootOption = {
  userId?: number
}

export type ChIdentification = {
  danalName?: string
  danalPhoneNumber?: string
}

export type ChProduct = {
  id?: components['schemas']['ProductDto']['id']
  name?: components['schemas']['ProductDto']['name']
  artist?: components['schemas']['ProductDto']['artist']
}

export type ChUserProduct = {
  id?: components['schemas']['UserProductDto']['id']
  subscriptionShares?: components['schemas']['UserProductDto']['subscriptionShares']
  balance?: components['schemas']['UserProductDto']['balance']
  createdDate?: components['schemas']['UserProductDto']['createdDate']
}

/** ChannelIO: 초기화 스크립트 로드 */
export const chLoadScript = () => {
  ChannelService.loadScript()
}

/** ChannelIO: "익명 유저" 혹은 "멤버 유저"로 채널톡 서비스 부트 */
export const chBoot = (options: ChBootOption, callback?: ChannelService.Callback) => {

  const env = process.env.REACT_APP_ENV ?? 'dev'

  const _makeMemberId = (userId: number, env: string) => {
    return `ARTIPIO${String(userId).padStart(10, '0')}${String(env.toUpperCase()).slice(0, 1)}`
  }

  if (options?.userId !== undefined) {
    const memberId = _makeMemberId(options.userId, env)
    ChannelService.boot({ pluginKey: CHANNEL_KEY, memberId: memberId }, callback)
  } else {
    ChannelService.boot({ pluginKey: CHANNEL_KEY }, callback)
  }
}

/** ChannelIO: 채널톡 서비스 익명 유저로 초기화(로그아웃, 탈퇴 시 사용) */
export const chClear = () => {
  ChannelService.shutdown()
  chBoot({})
}

/** ChannelIO: 채널톡 서비스에 사용자 정보 업데이트 */
export const chUpdateUser = (user: ChUser) => {
  const name = user?.identification?.danalName ?? user.name
  const email = user.email
  const mobileNumber =
    user?.identification?.danalPhoneNumber !== undefined
      ? format(user.identification.danalPhoneNumber, 'KR', 'E.164')
      : undefined

  const profile: ChProfile = { name, email }
  if (mobileNumber !== undefined) profile.mobileNumber = mobileNumber

  ChannelService.updateUser({ profile }, (e, user) => {
  })
}

/** ChannelIO: 회원가입 */
export const chSignup = (user: ChUser) => {
  chUpdateUser(user)
  ChannelService.track('signup')
}

/** ChannelIO: '청약 신청하기' 버튼을 클릭하고 매각 위탁에 대한 동의/투자계약서를 동의한 시점 */
export const chSuccessSubscriptionProduct = (
  identification?: ChIdentification,
  product?: ChProduct,
  userProduct?: ChUserProduct,
) => {
  const name = identification?.danalName ?? ''
  const productName = product?.name ?? ''
  const productArtist = product?.artist ?? ''

  let now = new Date()
  if (userProduct?.createdDate) now = new Date(userProduct?.createdDate)
  const createdDate = `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`

  const count = userProduct?.subscriptionShares ?? 0
  const amount = userProduct?.balance ?? 0
  const orderSequence = userProduct?.id ? String(userProduct?.id).padStart(8, '0') : ''

  const trackObj = { name, productName, productArtist, createdDate, count, amount, orderSequence }
  ChannelService.track('success_subscription_product', trackObj)
  ChannelService.addTags(['청약신청/3차'], (e, user) => {
  })

  return
}

/** ChannelIO: 자산상세 페이지에서 청약취소 버튼 클릭하여 '네' 버튼을 클릭한 시점 */
export const chCancelSubscriptionProduct = (
  identification?: ChIdentification,
  product?: ChProduct,
  userProduct?: ChUserProduct,
) => {
  const name = identification?.danalName ?? ''
  const productName = product?.name ?? ''
  const productArtist = product?.artist ?? ''

  const now = new Date()
  const createdDate = `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`

  const count = userProduct?.subscriptionShares ?? 0
  const amount = userProduct?.balance ?? 0
  const orderSequence = userProduct?.id ? String(userProduct?.id).padStart(8, '0') : ''

  const trackObj = { name, productName, productArtist, createdDate, count, amount, orderSequence }
  ChannelService.track('cancel_subscription_product', trackObj)

  ChannelService.removeTags(['청약신청/3차'])

  return
}
